import { useTranslation } from 'react-i18next';
import { ConfirmationPrompt } from '../../../../../../components/ConfirmationPrompt';
import { useDeleteInvitationSourceMappings } from './deleteInvitationSourceMappingsPanel/utility/useDeleteInvitationSourceMappings';

const DeleteInvitationSourceMappingsPanel = ({ hearingId }) => {
  const { t: translator } = useTranslation();
  const {
    isPopupOpen,
    isUpdating,
    deleteFromAllInvitationSources,
    setIsPopupOpen,
    onConfirm,
  } = useDeleteInvitationSourceMappings(hearingId);

  return (
    <ConfirmationPrompt
      isOpen={isPopupOpen}
      onDismiss={setIsPopupOpen}
      onConfirm={onConfirm}
      disabled={isUpdating}
      text={
        deleteFromAllInvitationSources
          ? translator(
              'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMappingsPanel.deleteFromAllInvitationSourcesPrompt',
            )
          : translator(
              'pages.createHearing.createHearingInvitations.inviteesList.deleteInvitationSourceMappingsPanel.deleteSingleSourceMappingPrompt',
            )
      }
    />
  );
};

export { DeleteInvitationSourceMappingsPanel };
